

















import {Component, Prop, PropSync, Vue} from 'vue-property-decorator'
import {
  DxTextArea
} from 'devextreme-vue/ui/text-area';
import {
  DxValidator,
  DxRequiredRule,
  DxEmailRule,
  DxStringLengthRule
} from 'devextreme-vue/validator';

@Component({
  name: 'DTextarea',
  components: {
    DxTextArea,
    DxValidator,
    DxRequiredRule,
    DxEmailRule,
    DxStringLengthRule
  }
})
export default class extends Vue {

  @PropSync('inputData') synceInputData!: string
  @Prop({ default: '' }) public title!: string;
  @Prop() public height!: any;
  @Prop({ default: false }) public isRequired!: boolean;
  @Prop({ default: false }) public isReadOnly!: boolean;
  @Prop({ default: false }) public disabled!: boolean;

  created() {

  }


}
